import React from "react";
import { Layout, Menu, Button, Space } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LoginOutlined, UserAddOutlined } from "@ant-design/icons";
import logo from "../assets/logo.png";

const { Header } = Layout;

const HEADER_OFFSET = 88;

const COLORS = {
  primary: "#3FB6C2",
  primaryDark: "#1F4E57",
  border: "#DCE7F3",
  text: "#1F2937",
};

export default function PublicHeader() {
  const navigate = useNavigate();
  const location = useLocation();

  const goHomeTop = () => {
    const scrollTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(scrollTop, 120);
    } else {
      scrollTop();
    }
  };

  const scrollWithOffset = (id) => {
    const doScroll = () => {
      const el = document.getElementById(id);
      if (!el) return;
      const y = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
      window.scrollTo({ top: y, behavior: "smooth" });
    };

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(doScroll, 120);
    } else {
      doScroll();
    }
  };

  return (
    <Header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        width: "100%",
        height: 72,
        display: "flex",
        alignItems: "center",
        background: "#FFFFFF",
        borderBottom: `1px solid ${COLORS.border}`,
        paddingInline: 24,
        boxShadow: "0 2px 12px rgba(31, 78, 87, 0.06)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", marginRight: 28 }}>
        <Link
          to="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            color: COLORS.text,
            textDecoration: "none",
          }}
          title="Patrick Sauter – Smart Routing"
          onClick={(event) => {
            event.preventDefault();
            goHomeTop();
          }}
        >
          <img
            src={logo}
            alt="Firmenlogo"
            style={{ height: 32, width: "auto", flexShrink: 0 }}
          />

          <span
            style={{
              fontWeight: 800,
              fontSize: 16,
              letterSpacing: 0.2,
              whiteSpace: "nowrap",
              color: COLORS.primaryDark,
            }}
          >
            Patrick Sauter – Smart Routing
          </span>
        </Link>
      </div>

      <Menu
        mode="horizontal"
        selectable={false}
        style={{
          flex: 1,
          border: "none",
          minWidth: 0,
          color: COLORS.text,
        }}
        items={[
          {
            key: "features",
            label: (
              <span onClick={() => scrollWithOffset("features")}>
                Funktionen
              </span>
            ),
          },
          {
            key: "how",
            label: (
              <span onClick={() => scrollWithOffset("how")}>
                So funktioniert’s
              </span>
            ),
          },
          {
            key: "faq",
            label: (
              <span onClick={() => scrollWithOffset("faq")}>
                Häufige Fragen
              </span>
            ),
          },
        ]}
      />

      <Space>
        <Link to="/login">
          <Button icon={<LoginOutlined />}>Login</Button>
        </Link>

        <Link to="/register">
          <Button type="primary" icon={<UserAddOutlined />}>
            Registrieren
          </Button>
        </Link>

        <Link to="/ueber-mich">
          <Button type="link">Über mich</Button>
        </Link>

        <Link to="/contact">
          <Button type="link">Kontakt</Button>
        </Link>

        <Link to="/impressum">
          <Button type="link">Impressum</Button>
        </Link>

        <Link to="/datenschutz">
          <Button type="link">Datenschutz</Button>
        </Link>
      </Space>
    </Header>
  );
}
